import { createAsyncThunk } from '@reduxjs/toolkit';
import i18next from 'i18next';

import { changeTariffFromBackend } from '@entities/tariff/lib';

import { dashboardActions } from './dashboardSlice';
import { DashboardSchema, UpdateInformationAboutObjectRequest } from './types/dashboardSchema';
import { Roles } from '../../../AddProject/types/types';
import {
    uploadProgressErrorCode,
    UploadProgressErrorPayload,
} from '../../../shared/constants/uploadProgressError';
import { handleFetchErrorsSwal } from '../../../shared/helpers/fetchHelpers';
import {
    ContactPerson,
    Customer,
    ManagerInformation,
    SetCustomerBody,
    ConstructionProgress,
} from '../../../TemporaryConmonents/DashboardInformation/types/dashboardInformation';

export const getDashboard = createAsyncThunk('dashboard/getDashboard', async (_, thunkApi) => {
    // @ts-ignore
    const getDashboardUrl = routable.getRoute('projectDashboard');

    try {
        const getDashboardResponse = await fetch(getDashboardUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!getDashboardResponse.ok) {
            const error = await getDashboardResponse.json();
            // @ts-ignore
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('swal.button.text.ok'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return thunkApi.rejectWithValue(error.message);
        }

        const { data } = await getDashboardResponse.json();

        thunkApi.dispatch(dashboardActions.setCustomers(data.information.customers));
        thunkApi.dispatch(dashboardActions.setManagers(data.information.contact_persons));
        if (data.information.project_users?.project_users?.manager) {
            thunkApi.dispatch(
                dashboardActions.setManager(data.information.project_users.project_users.manager)
            );
        }
        if (data.information.project_users?.sorted_users) {
            thunkApi.dispatch(
                dashboardActions.setSortedUsers(data.information.project_users.sorted_users)
            );
        }

        if (data.information.project_users?.project_users?.foreman) {
            thunkApi.dispatch(
                dashboardActions.setForeman(data.information.project_users.project_users.foreman)
            );
        }

        if (data.information.project_users?.project_users?.purchase_agent) {
            thunkApi.dispatch(
                dashboardActions.setPurchases(
                    data.information.project_users.project_users.purchase_agent
                )
            );
        }

        thunkApi.dispatch(dashboardActions.setVisualization(data.visualization));
        thunkApi.dispatch(dashboardActions.setProjectId(data.project_id));
        thunkApi.dispatch(dashboardActions.setProgress(data.step_by_step.media));
        thunkApi.dispatch(
            dashboardActions.setProgressTariffAccessEdit(data.step_by_step.tariff_access.edit)
        );
        const dashboardInformation: DashboardSchema = { ...data };
        dashboardInformation.albums = data.step_by_step.albums.map((album) => ({
            value: album.id,
            title: album.title,
        }));
        delete dashboardInformation.information.customers;
        delete dashboardInformation.visualization;
        // @ts-ignore
        delete dashboardInformation.project_users;
        // @ts-ignore
        delete dashboardInformation.step_by_step;
        delete dashboardInformation.information.contactPersons;

        return dashboardInformation;
    } catch (e) {
        // @ts-ignore
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
export const editInfo = createAsyncThunk(
    'dashboard/editInfo',
    async (body: UpdateInformationAboutObjectRequest, thunkApi) => {
        // @ts-ignore
        const editInfoUrl = routable.getRoute('editProjectInfo');

        const formattedBody = {
            name: body.name,
            address: body.address,
            latitude: body.coordinates.latitude,
            longitude: body.coordinates.longitude,
            contract_number: body.contract_number,
            contract_date: body.contract_date,
            description: body.description,
        };

        try {
            const editInfoResponse = await fetch(`${editInfoUrl}`, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!editInfoResponse.ok) {
                const error = await editInfoResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            await editInfoResponse.json();

            const state = thunkApi.getState();

            // @ts-ignore
            const projectId = await state.dashboardReducer.projectId;

            $(document).find(`[data-target-id="${projectId}"]`).find('.menu-title').text(body.name);

            // @ts-ignore
            const editWeatherUrl = routable.getRoute('projectWeather');

            const editWeatherResponse = await fetch(editWeatherUrl, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const { data: weatherData } = await editWeatherResponse.json();

            thunkApi.dispatch(dashboardActions.updateWeather(weatherData));
            thunkApi.dispatch(dashboardActions.onModalMode(null));

            return body;
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const setCustomer = createAsyncThunk(
    'dashboard/setCustomer',
    async (body: SetCustomerBody, thunkApi) => {
        // @ts-ignore
        const selectCustomerUrl = routable.getRoute('selectCustomer');

        const formattedBody = {
            guid: body.guid,
        };

        try {
            const setCustomerResponse = await fetch(`${selectCustomerUrl}`, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!setCustomerResponse.ok) {
                const error = await setCustomerResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            thunkApi.dispatch(dashboardActions.onModalMode(null));
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const setLegalEntity = createAsyncThunk(
    'dashboard/setLegalEntity',
    async (guid: SetCustomerBody['guid'], thunkApi) => {
        // @ts-ignore
        const setLegalEntityUrl = routable.getRoute('selectLegalEntity');

        const formattedBody = {
            guid,
        };

        try {
            const setLegalEntityResponse = await fetch(setLegalEntityUrl, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!setLegalEntityResponse.ok) {
                const error = await setLegalEntityResponse.json();

                if (error.status === 'tariff-error') {
                    await changeTariffFromBackend(error.tariff_popup_url);
                } else {
                    // @ts-ignore
                    swal({
                        text: error.message,
                        cancel: false,
                        confirm: true,
                        button: {
                            text: i18next.t('swal.button.text.ok'),
                            value: true,
                            visible: true,
                            className: 'btn btn-secondary',
                        },
                    });
                }

                return thunkApi.rejectWithValue(error.message);
            }
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const deleteCustomer = createAsyncThunk('dashboard/deleteCustomer', async (_, thunkApi) => {
    const state = thunkApi.getState();

    // @ts-ignore
    const currentCustomerId = await state.dashboardReducer.currentCustomerId;

    // @ts-ignore
    const deleteCustomerUrl = routable.getRoute('deleteCustomer');

    try {
        const deleteCustomerResponse = await fetch(deleteCustomerUrl, {
            method: 'DELETE',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!deleteCustomerResponse.ok) {
            const error = await deleteCustomerResponse.json();
            // @ts-ignore
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('swal.button.text.ok'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return thunkApi.rejectWithValue(error.message);
        }

        thunkApi.dispatch(dashboardActions.changeCurrentCustomerId(null));
        thunkApi.dispatch(dashboardActions.onModalMode(null));

        return currentCustomerId;
    } catch (e) {
        // @ts-ignore
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});

export const addCustomer = createAsyncThunk(
    'dashboard/addCustomer',
    async (body: Customer, thunkApi) => {
        // @ts-ignore
        const addCustomerUrl = routable.getRoute('createCustomer');

        const formattedBody = {
            name: body.name,
            email: body.email,
            phone: body.phone,
            description: body.description,
            full_name: body.full_name,
            legal_address: body.legal_address,
            passport: body.passport,
            inn: body.inn,
            kpp: body.kpp,
            ogrn: body.ogrn,
            ogrnip: body.ogrnip,
            okpo: body.okpo,
            bank: body.bank,
            bik: body.bik,
            correspondent_account_number: body.correspondent_account_number,
            current_account_number: body.current_account_number,
            contact_name: body.contact_name,
            actual_address: body.actual_address,
            contact_comment: body.contact_comment,
        };

        try {
            const addCustomerResponse = await fetch(`${addCustomerUrl}`, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!addCustomerResponse.ok) {
                const error = await addCustomerResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { data } = await addCustomerResponse.json();

            const setCustomerResponse = await thunkApi.dispatch(setCustomer({ guid: data.guid }));
            // @ts-ignore
            if (setCustomerResponse.error) {
                // @ts-ignore
                return thunkApi.rejectWithValue(setCustomerResponse.error.message);
            }
            thunkApi.dispatch(dashboardActions.onModalMode(null));

            return data;
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const editCustomer = createAsyncThunk(
    'dashboard/editCustomer',
    async (body: Customer, thunkApi) => {
        const state = thunkApi.getState();

        // @ts-ignore
        const currentCustomerId = await state.dashboardReducer.currentCustomerId;
        // @ts-ignore
        const editCustomerUrl = helpable.replaceUrlParameters(routable.getRoute('updateCustomer'), {
            // @ts-ignore
            _companyPartner_: currentCustomerId,
        });

        const formattedBody = {
            name: body.name,
            email: body.email,
            phone: body.phone,
            description: body.description,
            full_name: body.full_name,
            legal_address: body.legal_address,
            passport: body.passport,
            inn: body.inn,
            kpp: body.kpp,
            ogrn: body.ogrn,
            ogrnip: body.ogrnip,
            okpo: body.okpo,
            bank: body.bank,
            bik: body.bik,
            correspondent_account_number: body.correspondent_account_number,
            current_account_number: body.current_account_number,
            contact_name: body.contact_name,
            actual_address: body.actual_address,
            contact_comment: body.contact_comment,
        };

        try {
            const editCustomerResponse = await fetch(editCustomerUrl, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!editCustomerResponse.ok) {
                const error = await editCustomerResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            thunkApi.dispatch(dashboardActions.onModalMode(null));

            return { id: currentCustomerId, name: body.name };
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const createManager = createAsyncThunk(
    'dashboard/addManager',
    async (body: ManagerInformation, thunkApi) => {
        // @ts-ignore
        const addManagerUrl = routable.getRoute('createManager');

        const formattedBody = {
            full_name: body.full_name,
            position: body.position,
            email: body.email,
            phone: body.phone,
        };

        try {
            const createManagerResponse = await fetch(addManagerUrl, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!createManagerResponse.ok) {
                const error = await createManagerResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { data } = await createManagerResponse.json();

            const updatedManager: ContactPerson = {
                name: data.contact_person.full_name,
                guid: data.contact_person.guid,
                id: data.contact_person.id,
                preview_url: data.contact_person.preview_url,
            };
            thunkApi.dispatch(dashboardActions.addManager(updatedManager));
            thunkApi.dispatch(dashboardActions.setSortedUsers(data.project_users.sorted_users));
            if (data.project_users.project_users?.manager) {
                thunkApi.dispatch(
                    dashboardActions.setManager(data.project_users.project_users.manager)
                );
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectManager());
            }
            if (data.project_users.project_users?.foreman) {
                thunkApi.dispatch(
                    dashboardActions.setForeman(data.project_users.project_users.foreman)
                );
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectForeman());
            }
            if (data.project_users.project_users?.purchase_agent) {
                thunkApi.dispatch(
                    dashboardActions.setPurchases(data.project_users.project_users.purchase_agent)
                );
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectPurchases());
            }
            thunkApi.dispatch(dashboardActions.onModalMode(null));
            return data.contact_person;
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const editManager = createAsyncThunk(
    'dashboard/editManager',
    async (body: ManagerInformation, thunkApi) => {
        const state = thunkApi.getState();

        // @ts-ignore
        const currentManagerId = await state.dashboardReducer.currentManagerId;
        // @ts-ignore
        const editManagerUrl = helpable.replaceUrlParameters(routable.getRoute('updateManager'), {
            // @ts-ignore
            _managerId_: currentManagerId,
        });

        const formattedBody = {
            full_name: body.full_name,
            position: body.position,
            email: body.email,
            phone: body.phone,
        };

        try {
            const editManagerResponse = await fetch(editManagerUrl, {
                method: 'POST',
                body: JSON.stringify(formattedBody),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
            });

            if (!editManagerResponse.ok) {
                const error = await editManagerResponse.json();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            thunkApi.dispatch(dashboardActions.onModalMode(null));
            const { data } = await editManagerResponse.json();
            const updatedManager: ContactPerson = {
                name: data.contact_person.full_name,
                guid: data.contact_person.guid,
                id: data.contact_person.id,
                preview_url: data.contact_person.preview_url,
            };
            return updatedManager;
        } catch (e) {
            // @ts-ignore
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const deleteManager = createAsyncThunk(
    'dashboard/deleteManager',
    async (body: ContactPerson, thunkApi) => {
        const state = thunkApi.getState();

        // @ts-ignore
        const currentManagerId = await state.dashboardReducer.currentManagerId;

        // @ts-ignore
        const deleteManagerUrl = helpable.replaceUrlParameters(routable.getRoute('deleteManager'), {
            // @ts-ignore
            _managerId_: currentManagerId,
        });

        try {
            const removeManagerResponse = await fetch(deleteManagerUrl, {
                method: 'DELETE',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!removeManagerResponse.ok) {
                const error = await removeManagerResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            return currentManagerId;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const uploadVisualization = createAsyncThunk(
    'dashboard/uploadVisualization',
    async (formData: FormData, thunkApi) => {
        // @ts-ignore
        const uploadVisualizationUrl = routable.getRoute('uploadProjectPhotoAjaxUrl');
        // @ts-ignore
        const getVisualizationUrl = routable.getRoute('getVisualization');

        try {
            // @ts-ignore
            loader.show();
            const uploadVisualizationResponse = await fetch(uploadVisualizationUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!uploadVisualizationResponse.ok) {
                const error = await uploadVisualizationResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { error } = await uploadVisualizationResponse.json();
            if (error) {
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error);
            }
            const getVisualizationResponse = await fetch(getVisualizationUrl, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });
            const { data } = await getVisualizationResponse.json();
            // @ts-ignore
            loader.hide();

            return data;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const removeVisualization = createAsyncThunk(
    'dashboard/removeVisualization',
    async (id: number, thunkApi) => {
        // @ts-ignore
        const url = helpable.replaceUrlParameters(
            // @ts-ignore
            routable.getRoute('removeProjectPhotoAjaxUrl'),
            { _id_: id }
        );

        try {
            // @ts-ignore
            loader.show();

            const removeVisualizationResponse = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!removeVisualizationResponse.ok) {
                const error = await removeVisualizationResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { error } = await removeVisualizationResponse.json();

            if (error) {
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error);
            }
            // @ts-ignore
            loader.hide();
            thunkApi.dispatch(dashboardActions.removeVisualization(id));
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const removeProgress = createAsyncThunk(
    'dashboard/removeProgress',
    async (id: number, thunkApi) => {
        try {
            // @ts-ignore
            const url = helpable.replaceUrlParameters(
                // @ts-ignore
                routable.getRoute('removeStepByStepMediaAjaxUrl'),
                { _id_: id }
            );

            // @ts-ignore
            loader.show();

            const removeProgressResponse = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!removeProgressResponse.ok) {
                const error = await removeProgressResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { error } = await removeProgressResponse.json();

            if (error) {
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error);
            }
            // @ts-ignore
            loader.hide();
            thunkApi.dispatch(dashboardActions.removeProgress(id));
            thunkApi.dispatch(getProgressMediaList());
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const editProgress = createAsyncThunk(
    'dashboard/editProgress',
    async (body: ConstructionProgress, thunkApi) => {
        // @ts-ignore
        const getImages = routable.getRoute('stepByStepMediaListAjax');
        // @ts-ignore
        const url = helpable.replaceUrlParameters(
            // @ts-ignore
            routable.getRoute('updateStepByStepMediaInfoAjaxUrl'),
            { _id_: body.id }
        );

        try {
            // @ts-ignore
            loader.show();

            const formData = new FormData();
            formData.append('date', body.date);
            formData.append('description', body.description);
            body.albums.forEach((album) => {
                formData.append('albums[]', album.title);
            });

            const editProgressResponse = await fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!editProgressResponse.ok) {
                const error = await editProgressResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { error } = await editProgressResponse.json();

            if (error) {
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error);
            }

            await thunkApi.dispatch(getProgressMediaList()).unwrap();

            // @ts-ignore
            loader.hide();
            thunkApi.dispatch(dashboardActions.onModalMode(null));
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);
export const massAddingInAlbums = createAsyncThunk(
    'dashboard/editProgress',
    async (
        body: {
            media_ids: string[];
            albums: string[];
        },
        thunkApi
    ) => {
        // @ts-ignore
        const getImages = routable.getRoute('stepByStepMediaListAjax');
        // @ts-ignore
        const url = routable.getRoute('stepByStepMediaAddToAlbums');

        try {
            // @ts-ignore
            loader.show();

            const massAddingInAlbumsResponse = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!massAddingInAlbumsResponse.ok) {
                const error = await massAddingInAlbumsResponse.json();
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error.message);
            }

            const { error } = await massAddingInAlbumsResponse.json();

            if (error) {
                // @ts-ignore
                loader.hide();
                // @ts-ignore
                swal({
                    text: error,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('swal.button.text.ok'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return thunkApi.rejectWithValue(error);
            }

            await thunkApi.dispatch(getProgressMediaList()).unwrap();

            // @ts-ignore
            loader.hide();
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const uploadProgress = createAsyncThunk(
    'dashboard/uploadProgress',
    async ({ formData, signal }: { formData: FormData; signal?: AbortSignal }, thunkApi) => {
        // @ts-ignore
        const url = routable.getRoute('stepByStepMediaUpload');

        try {
            const uploadProgressResponse = await fetch(url, {
                method: 'POST',
                body: formData,
                signal,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!uploadProgressResponse.ok) {
                const error = await uploadProgressResponse.json();
                return thunkApi.rejectWithValue({
                    code: uploadProgressErrorCode.SERVER_ERROR,
                    message: error?.message || '',
                } as UploadProgressErrorPayload);
            }

            const uploadProgressResult = await uploadProgressResponse.json();
            return uploadProgressResult?.data || [];
        } catch (error) {
            if ((error as Error)?.name === 'AbortError') {
                return thunkApi.rejectWithValue({
                    code: uploadProgressErrorCode.ABORTED,
                } as UploadProgressErrorPayload);
            }
            if (error instanceof TypeError) {
                return thunkApi.rejectWithValue({
                    code: uploadProgressErrorCode.NETWORK_FAILED,
                    message: error.message,
                } as UploadProgressErrorPayload);
            }
            return thunkApi.rejectWithValue({
                code: uploadProgressErrorCode.SERVER_ERROR,
                message:
                    (error as Error)?.message ||
                    (typeof error === 'string' ? error : String(error)),
            } as UploadProgressErrorPayload);
        }
    }
);

export const getProgressMediaList = createAsyncThunk(
    'dashboard/getProgressMediaList',
    async (albumIds: number[] | undefined, thunkApi) => {
        // @ts-ignore
        const getImages = routable.getRoute('stepByStepMediaListAjax');
        // @ts-ignore
        const state = thunkApi.getState().dashboardReducer;
        const selectedAlbumIds = albumIds ?? state.selectedAlbums;

        const searchParams = new URLSearchParams();

        selectedAlbumIds.forEach((id) => {
            searchParams.append('albums[]', String(id));
        });

        const url = searchParams.toString() ? `${getImages}?${searchParams.toString()}` : getImages;

        try {
            const getImagesResponse = await fetch(url, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!getImagesResponse.ok) {
                const error = await getImagesResponse.json();
                return thunkApi.rejectWithValue(error.message);
            }

            const { data, albums } = await getImagesResponse.json();
            thunkApi.dispatch(
                dashboardActions.setAlbums(
                    albums.map((album) => ({ title: album.title, value: album.id }))
                )
            );

            const albumIdsSet = new Set((albums || []).map((a: { id: number }) => a.id));
            const validSelectedIds = selectedAlbumIds.filter((id) => albumIdsSet.has(id));

            if (validSelectedIds.length !== selectedAlbumIds.length) {
                thunkApi.dispatch(dashboardActions.setSelectedAlbums(validSelectedIds));

                if (validSelectedIds.length > 0) {
                    const reloadParams = new URLSearchParams();
                    validSelectedIds.forEach((id) => reloadParams.append('albums[]', String(id)));
                    const reloadUrl = `${getImages}?${reloadParams.toString()}`;
                    const reloadResponse = await fetch(reloadUrl, {
                        method: 'GET',
                        headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    });
                    if (reloadResponse.ok) {
                        const reloadResult = await reloadResponse.json();
                        thunkApi.dispatch(dashboardActions.addProgress(reloadResult.data));
                        thunkApi.dispatch(
                            dashboardActions.setAlbums(
                                reloadResult.albums.map((album) => ({
                                    title: album.title,
                                    value: album.id,
                                }))
                            )
                        );
                    }
                } else {
                    const reloadResponse = await fetch(getImages, {
                        method: 'GET',
                        headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    });
                    if (reloadResponse.ok) {
                        const reloadResult = await reloadResponse.json();

                        thunkApi.dispatch(dashboardActions.addProgress(reloadResult.data));
                        thunkApi.dispatch(
                            dashboardActions.setAlbums(
                                reloadResult.albums.map((album) => ({
                                    title: album.title,
                                    value: album.id,
                                }))
                            )
                        );
                    }
                }
            } else {
                thunkApi.dispatch(dashboardActions.addProgress(data));
                thunkApi.dispatch(dashboardActions.setSelectedAlbums(validSelectedIds));
            }
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const deleteProjectUser = createAsyncThunk(
    'dashboard/deleteProjectUser',
    async (
        {
            id,
            role,
        }: {
            id: string;
            role: Roles;
        },
        thunkApi
    ) => {
        // @ts-ignore
        const url = helpable.replaceUrlParameters(
            // @ts-ignore
            routable.getRoute('deleteProjectUserDash'),
            {
                _projectUserId_: id,
            }
        );

        try {
            const response = await fetch(url, {
                method: 'DELETE',
            });
            await handleFetchErrorsSwal(response);

            const { data } = await response.json();

            thunkApi.dispatch(dashboardActions.setSortedUsers(data.sorted_users));
            if (data.project_users?.manager) {
                thunkApi.dispatch(dashboardActions.setManager(data.project_users.manager));
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectManager());
            }

            if (data.project_users?.foreman) {
                thunkApi.dispatch(dashboardActions.setForeman(data.project_users.foreman));
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectForeman());
            }
            if (data.project_users?.purchase_agent) {
                thunkApi.dispatch(dashboardActions.setPurchases(data.project_users.purchase_agent));
            } else {
                thunkApi.dispatch(dashboardActions.removeProjectPurchases());
            }
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const onAddProjectUser = createAsyncThunk(
    'dashboard/addProjectUser',
    async (
        body: {
            email: string;
            role: string;
        },
        thunkApi
    ) => {
        // @ts-ignore
        const url = routable.getRoute('addProjectUserDash');

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(body),
            });

            const res = await response.json();

            if (res.status === 'error') {
                return thunkApi.rejectWithValue({
                    status: 'error',
                    message: res.message,
                });
            }
            if (res.status === 'tariff-error') {
                return thunkApi.rejectWithValue({
                    status: 'tariff-error',
                    is_owner: res.is_owner,
                    message: res.message,
                });
            }

            thunkApi.dispatch(dashboardActions.setSortedUsers(res.data.sorted_users));
            if (res.data.project_users.manager) {
                thunkApi.dispatch(dashboardActions.setManager(res.data.project_users.manager));
            }

            if (res.data.project_users.foreman) {
                thunkApi.dispatch(dashboardActions.setForeman(res.data.project_users.foreman));
            }
            if (res.data.project_users.purchase_agent) {
                thunkApi.dispatch(
                    dashboardActions.setPurchases(res.data.project_users.purchase_agent)
                );
            }
            return res.data;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);
